import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TonalAudiometry from "../tonal-audiometry/tonalAudiometry";
import LoginModal from "../../modal/loginModal/loginModal";
import RegisterModal from "../../modal/registerModal/registerModal";

const Login: React.FC = () => {
  const [showLogin, setShowLogin] = useState(true);
  const [showRegister, setShowRegister] = useState(false);
  const navigate = useNavigate();

  const closeRoute = () => {
    setShowLogin(false);
    setShowRegister(false);
    navigate("/");
  };

  const openRegister = () => {
    setShowLogin(false);
    setShowRegister(true);
  };

  const openLogin = () => {
    setShowRegister(false);
    setShowLogin(true);
  };

  return (
    <>
      <TonalAudiometry />

      <LoginModal
        isOpen={showLogin}
        onClose={closeRoute}
        onOpenRegister={openRegister}
      />
      <RegisterModal
        isOpen={showRegister}
        onClose={closeRoute}
        onOpenLogin={openLogin}
      />
    </>
  );
};

export default Login;